export const GOVGR__DRAWER_CLOSE_ICON = "govgr--drawer__close-icon";
export const GOVGR_CLOSE_ICON = "govgr-close-icon";
export const GOVGR_SVG_ICON = "govgr-svg-icon";
export const GOVGR_ADMIN_SIDE_CONTENT = "govgr-admin-side-content";
export const GOVGR_DRAWER_LEFT = "govgr--drawer__left";
export const GOVGR_DRAWER_SIDE = "govgr-drawer__side";
export const GOVGR_DRAWER_CONTENT = "govgr-drawer__content";
export const GOVGR_DRAWER_HEADER_CONTAINER = "govgr--drawer__header-container";
export const GOVGR_HEADING_M = "govgr--drawer__header-container";
export const GOVGR_LIST = "govgr-list";
export const GOVGR_LIST_ITEM = "govgr-list__item";
export const GOVGR_ADMIN_FOOTER = "govgr-admin-footer";
export const GOVGR_ADMIN_WIDTH_CONTAINER = "govgr-admin-width-container";
export const GOVGR_FOOTER_META = "govgr-footer__meta";
export const GOVGR_FOOTER_META_ITEM = "govgr-footer__meta-item";
export const GOVGR_FOOTER_META_ITEM_GROW = "govgr-footer__meta-item--grow";
export const GOVGR_FOOTER_CONTENT = "govgr-footer__content";
export const GOVGR_FOOTER_LICENT_DESCRIPTION =
  "govgr-footer__licence-description";
export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";
export const GOVGR_FOOTER_GOVERMENT_LOGO = "govgr-footer__government-logo";
export const GOVGR_DRAWER_BURGER_ICON = "govgr--drawer__burger-icon";
export const GOVGR_BTN_SECONDARY = "govgr-btn-secondary";
export const GOVGR_BTN = "govgr-btn";
export const GOVGR_BURGER_ICON = "govgr-burger-icon";
export const GOVGR_ADMIN_HEADER_CONTENT = "govgr-admin-header__content";
export const GOVGR_HEADER_LINK = "govgr-header-link";
export const GOVGR_HEADER_LOGO = "govgr-header-logo";
export const GOVGR_HEADER_TITLE = "govgr-header-title";
export const GOVGR_LAYOUT_WRAPPER = "govgr-layout-wrapper";
export const GOVGR_LAYOUT_WRAPPER_FULL_HEIGHT =
  "govgr-layout-wrapper__full-height";
export const GOVGR_ADMIN_HEADER = "govgr-admin-header";
export const GOVGR_ADMIN_HEADER_CONTAINER = "govgr-admin-header__container";
export const GOVGR_ADMIN_MAIN_WRAPPER = "govgr-admin-main-wrapper";
export const GOVGR_ADMIN_MAIN_CONTENT = "govgr-admin-main-content";
export const GOVGR_BTN_SECONDARY_CUSTOM_COLOR =
  "govgr-btn-secondary-customcolor";
export const GOV_GR_DROPDOWN = "govgr-dropdown";
export const GOVGR_BTN_CUSTOMCOLOR = "govgr-btn-customcolor";
export const GOVGR_SVG_ICON__MORE_VERT = "govgr-svg-icon--more-vert";
export const GOVGR_DROPDOWN__CONTENT = "govgr-dropdown__content";
export const GOVGR_VERTICAL_NAV = "govgr-vertical-nav";
export const GOVGR_LINK = "govgr-link ";
export const GOVGR_VERTICAL_NAV_ITEM = "govgr-vertical-nav__item";
